import React from 'react';

// Local Dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { widgetsTabFlow as WidgetsTabFlow } from 'modules/widgetsTabFlow';
import { heartBeatPreloader as HeartBeatPreloader } from 'ui/views/generic/heartBeatPreloader';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { callItemDetailInnerTab as CallItemDetailInnerTab } from 'ui/views/widgets/callItemDetailInnerTab';
 *
 * // render
 * <CallItemDetailInnerTab propName='propValue'/>
 */
export const callItemDetailInnerTabSuccess = ( props ) => {
    return (
        <div className='ui-call-item-detail-inner-tab'>
            <WidgetsTabFlow
                tabs={ props.tabs }
                theme='plain'
                requestPayload={ props.requestPayload }
                onTabActionClick= { props.onViewActionClick }
            />
        </div>
    );
};

// set display name
callItemDetailInnerTabSuccess.displayName = 'callItemDetailInnerTabSuccess';

// set default props
callItemDetailInnerTabSuccess.defaultProps = {};

// prop types
callItemDetailInnerTabSuccess.propTypes = {};

// Preloader view
export const callItemDetailInnerTabPreloader = () => {
    return (
        <div className='ui-call-item-detail-inner-tab-preloader'>
           <HeartBeatPreloader />
        </div>
    );
};

// set display name
callItemDetailInnerTabPreloader.displayName = 'callItemDetailInnerTabPreloader';

// set default props
callItemDetailInnerTabPreloader.defaultProps = {};

// prop types
callItemDetailInnerTabPreloader.propTypes = {};

export const callItemDetailInnerTab = withNetworkState( callItemDetailInnerTabPreloader, callItemDetailInnerTabSuccess );
